const strings = {
    en: {
        Marketing: {
            LogIn: 'Log In',

            HeroTitle: 'Record, Reflect, Respond!',
            HeroDescriptionBold: `The World's #1 Video Prompt Recorder `,
            HeroDescription: 'with AI-powered transcription, translation, personalized follow-ups, individualized assessments and more.',

            AIAssistedDiscussions: 'Instant Discussions',
            AIAssistedDiscussionsDescription: 'Record prompts right from your browser! Add attachments and then invite the whole class to respond.',
            AIAssistedDiscussionsDescription2: 'Ignite accessible learning through AI-powered transcription, multilingual translation, and automated assessment of any conversation.',
            WatchHow: 'Watch How Gravity Works',

            KeywordsInsights: 'Empower Every Voice',
            KeywordsInsightsDescription: 'Instantly extract and define spoken keywords, providing thought equity for all.',
            KeywordsInsightsDescription2: 'Automatically generate deep assessments of comprehension as well as interactions between fellow learners.',

            DifferentiatedLearning: 'Differentiated Learning',
            DifferentiatedLearningDescription: 'Carve out personalized paths unique to your student\'s learning style.',
            DifferentiatedLearningDescription2: 'Vary instructional strategies by providing an innovative way for your students to express their understanding.',

            CallOut: `COPPA, FERPA, and GDPR Compliant`,
            CallOut2: `No RFPs Required. Ask us about our Interlocal Agreement.`,

            ThoughtEquity: 'Thought Equity',
            ThoughtEquityDescription: 'Gravity provides the time and space to give well-thought-out answers. No pop quiz responses, no race to raise your hand - everyone gets a chance to express their own unique point of view. It is more important than ever before to create a plurality of perspectives.',
            ResearchBacked: 'Research-Backed',
            ResearchBackedDescription: 'Gravity was selected for quantitative research at Johns Hopkins University School of Education and was found to significantly increase learning outcomes.',
            ByEducators: 'By Educators, For Educators',
            ByEducatorsDescription: 'Gravity was built by a team of teachers, professors, and technologists who believe in the power of education to change the world.',
            MagicAIPrompts: 'Premium Prompts',
            UnlimitedRecording: 'Unlimited Recording',
            AIVoiceToneAnalysis: 'Instantly translate and voice dub videos into 12+ world languages!',
            ReadyToSupercharge: 'Ready to supercharge your classroom?',
            YesIAm: 'Yes, I am - Let\'s go!',
            StartForFree: 'Start Free!',
            StartForFreeDescription: 'Start instantly with our Free version before committing',
            StartForFreeCallout: 'No Credit Card Required',
            AffordablePricing: 'A Plan For Everyone',
            AffordablePricingDescription: 'Creating a community is easy and affordable. Start for FREE with recording plans as low as $6 per month.',
            AffordablePricingCallout: '30% Discount on Yearly!',
            Privacy: 'Privacy Policy',
            TOS: 'Terms of Service'
        },
        Header: {
            Logout: 'Logout',
            EditProfile: 'Edit Profile',
            MonthlyRecordingLimit: 'Monthly Recording Limit',
            MinutesRemaining: 'Minutes Remaining',
            New: 'NEW',
            ComingSoon: 'COMING SOON',
            BrandNewPricing: 'Gravity 4.0',
            ComingApril: 'New Pricing + AI Assessments!',
            IsHere: 'is here',
            VoiceOverText: 'Instantly translate and dub any Premium Prompt discussion into multiple languages',
            FollowUpText: 'Answer a personalized, AI-generated follow-up question based on your response',
        },
        Register: {
            Greeting: 'Howdy',
            GetRegistered: 'Let\'s get you registered',
            HaveJoinCode: 'I have a Join Code',
            CreateCommunity: 'Create a New Community',
            JoinCode: 'Join Code',
            NewCommunity: 'New Community',
            SixCode: 'Please enter your 6 character code',
            CommunityName: 'What do you want to name your community?',
            CreateAccount: 'Create Account',
            ToJoin: 'to join ',
            ThisCommunity: 'this community',
            ToStart: 'to start ',
            YourCommunity: 'your community',
            Now: ' now'
        },
        Dashboard: {
            BookDemo: 'Book a Gravity 15-Minute Live Demo for FREE!',
            Dashboard: 'Dashboard',
            Watched: 'Watched',
            Videos: 'Videos',
            Created: 'Created',
            Recordings: 'Recordings',
            Responded: 'Responded',
            Conversations: 'Conversations',
            CreatorStudio: 'Creator Studio',
            QuickPrompt: 'Quick Prompt',
            MagicAIPrompt: 'Record A Prompt',
            MagicAI: 'Gravity AI',
            Left: 'Left',
            Unlock: 'Unlock',
            RecentVideos: 'Recent Videos',
            Engagement: 'Engagement',
            QuickMenu: 'Quick Menu',
            CheckMirror: 'Check Mirror',
            Tutorials: 'Tutorials',
            TutorialsDescription: 'Tutorials and knowledge, just for you!',
            BackToDashboard: 'Back to Dashboard',
            BackToTutorials: 'Back to Tutorials',
        },
        Search: {
            NoResults: 'No results',
            Create: 'Create'
        },
        LoginRegister: {
            EmailAddress: 'Email Address',
            Password: 'Password',
            Login: 'Login',
            Register: 'Register',
            FullName: 'Full Name',
            FullNamePlaceholder: 'Jane Johnson',
            CommunitySearch: 'Community Search',
            CommunitySearchPlaceholder: 'Search for Community',
            CheckAvailability: 'Check Availability',
            AccountType: 'I am a',
            Uppercase: 'Uppercase Letter',
            Lowercase: 'Lowercase Letter',
            Number: 'Number',
            SpecialCharacter: 'Special Character',
            MinimumCharacters: 'Minimum Characters',
            RestoringSession: 'Restoring session',
            LogInToGravity: 'Log in to Gravity',
            NewToGravity: 'New to Gravity?',
            ForgotPassword: 'Forgot Password?',
            Request: 'Request',
            GoBack: 'Go Back',
            RequestSent: 'Request Sent',
            Continue: 'Continue'
        },
        Package: {
            Basic: 'Basic',
            RecordAndShare: 'Record + Share',
            Free: 'Free',
            Includes: 'Includes',
            ThirtyMin: '30-Min Shared Recording Limit',
            Community: 'Community',
            Folders: 'Folders',
            GetStarted: 'Get Started',
            Basic: 'Basic',
            Premium: 'Premium',
            Unlimited: 'Unlimited',
            UnlimitedEverything: 'Unlimited Everything',
            AIWorkflows: 'AI Workflows',
            PerMonth: 'per month',
            EverythingInBasicPlus: 'Everything in Basic, plus',
            UnlimitedRecordingLimit: 'Unlimited Recording Limit',
            UnlimitedCommunities: 'Unlimited Communities',
            UnlimitedFolders: 'Unlimited Folders',
            AIVoiceToneAnalysis: 'AI VoiceOver',
            AIAutoTranscription: 'AI Auto Transcription',
            AIKeywordsAndInsights: 'AI Keywords & Insights',
            StartNow: 'Start Now',
            Enterprise: 'Enterprise',
            AdminAndAnalytics: 'Admin + Analytics',
            Custom: 'Custom',
            EverythingInPremiumPlus: 'Everything in Premium, plus',
            AnalyticsAndUsage: 'Analytics & Usage',
            DocumentAttachments: 'Document Attachments',
            DocumentAttachmentsDescription: 'Attach documents, Canva, FigJam, Google Drive and more!',
            MonthlyEngagementReports: 'Monthly Engagement Reports',
            DedicatedAccountManager: 'Dedicated Account Manager',
            TwentyFourSevenSupport: '24/7 Support',
            LetsTalk: 'Let\'s Talk',
            OneMinuteRecordingLimit: '1-Minute Recording Limit',
            UnlimitedMagicAIPrompts: 'Unlimited Premium Prompts',
            UnlimitedMagicAIPromptsDescription: 'Instantly create entire lessons with a single recording',
            UnlimitedRecordingLimitDescription: 'Record as much as you want without any limitations',
            AIVoiceToneAnalysisDescription: 'Instantly translate and voice dub into 12+ world languages on-demand!',
            AIAutoTranscriptionDescription: 'Increase accessibility, engagement, and learning outcomes',
            AIKeywordsAndInsightsDescription: 'Keywords extraction, instant definitions and suggested content',
            AnalyticsAndUsageDescription: 'Detailed reports usage, engagement, what\'s working and what\'s not',
            MagicAIPrompts: 'Premium Prompts',
            UnlimitedRecording: 'Unlimited Recording',
        },
        Pricing: {
            Basic: 'Basic',
            BasicPrice: 'Free',
            BasicDetails: 'Unlimited Participants for K-12 Educators',
            StartCreating: 'Participate, Record, and Share',
            RecordAnswerPrompts: 'Record and Answer Prompts',
            CreateCommunities: 'Create Communities',
            CreateNumberCommunities: 'Create up to 1 Community',
            CreateTwentyFiveParticipants: 'Invite up to 25 Participants',
            RecordUnlimitedPrompts: '<span className="unlimited">Unlimited</span> Prompt Recording',
            OneMinuteRecordingTime: '1-Minute Recording Time / Prompt',
            StartNow: 'Begin Basic',
            Premium: 'Premium',
            PremiumPrice: '$12/month',
            PremiumDetails: '50% Discount for K-12 Educators',
            AttachmentAIMore: 'AI, Attachments and More',
            CreateUnlimitedCommunities: '<span className="unlimited">Unlimited</span> Community Creation',
            InviteUnlimitedParticipants: '<span className="unlimited">Unlimited</span> Participant Invitations',
            UnlimitedRecordingTime: '<span className="unlimited">Unlimited</span> Recording Time / Prompt',
            AttachDocumentsVideos: '<span className="unlimited">Attach</span> Documents, Images and Videos',
            AIPoweredFeatures: '<span className="unlimited">AI-Powered</span> Creation Workflows',
            CreateNow: 'Start Premium',
            District: 'Are you a district or institution?',
            ContactPricing: 'Contact Us For Pricing',
        },
        Menu: {
            Select: 'Select',
            Create: 'Create',
            CommunityBegin: 'a community to begin.',
            Communities: 'Communities',
            Folders: 'Folders',

            AddCommunity: 'Add Community',
            AddCommunityDescription: 'Join or create a community for people to collaborate, converse and discover what\'s next.',
            AddCommunityNotAllowed: 'Join a community for people to collaborate, converse and discover what\'s next. To create a new community, upgrade to Premium.',
            AddCommunityName: 'Community Name',
            AddCommunityPlaceholder: 'ex. DEJ073',
            CreateCommunityPlaceholder: 'ex. Mulberry Street School',

            AddJoinCode: 'Enter Join Code',
            AddJoinCodeDescription: 'Join your classmate community to collaborate, converse and discover what\'s next.',
            AddJoinCodeName: 'Join Code',
            AddJoinCodePlaceholder: 'ex. 0XF78D',

            CreateFolder: 'Create a folder',
            CreateFolderDescription: 'Gather people in your community into focussed groups to discuss anything. Build collaborative conversations, polls and more.',
            CreateFolderName: 'Folder Name',
            CreateFolderPlaceholder: 'ex. European History Class',
            UniqueName: 'Unique Name',

            InviteMembers: 'Invite Members',
            InviteMembersDescription: 'Enter the email address of who to invite to your community.',
            InviteMembersPlaceholder: 'example@email.com',
            InviteButton: 'Send Invitation',
            InviteSent: 'Sent',

            ConfirmDelete: 'Delete Folder',
            ConfirmDeleteDescription: 'Are you sure you want to delete',
            ConfirmDeleteDiscussion: 'Delete Discussion',
            ConfirmDeleteResponse: 'Delete Response',
            ConfirmDeleteBackground: 'Delete Background',
            ConfirmDeleteBackgroundDescription: 'Are you sure you want to delete this background?',

            ConfirmRemoveMember: 'Remove Member',
            ConfirmRemoveMemberDescription: 'Are you sure you want to remove',
            ConfirmRemoveMemberDescription2: '',

            CreateFolderStart: 'Create a folder to start collaborating!',
            Duplicate: 'Duplicate',
            ConfirmDuplicate: 'Duplicate Folder',
            ConfirmDuplicateDescription: 'will be duplicated without the responses. Please enter a unique name for the new folder.',

            EditCommunities: 'Edit Communities',
            EditCommunitiesDescription: 'Rename, delete or duplicate your communities.',

            EditFolders: 'Edit Folders',
            EditFoldersDescription: 'Rename, delete or duplicate your folders.',
        },
        Modal: {
            Cancel: 'Cancel',
            Submit: 'Submit',
            Remove: 'Remove',
            SubmitContinue: 'Submit & Continue',
            Loading: 'Loading',
            Uploading: 'Uploading',
            Close: 'Close',
            Delete: 'Delete',
            ShortDescription: 'Prompt Description (Required)',
            ShortDescriptionPlaceholder: 'Please speak for 2 minutes about...',
            SpaceType: 'Space Type',
            Conversation: 'Conversation',
            ConversationDescription: 'Conversations allow you to record, respond and collaborate with classmates any time.',
            Poll: 'Poll',
            PollDescription: 'Ready to weigh options or reach concensus? Start a poll and let the community speak.',
            VideoRecording: 'Video Recording',
            AttachFile: 'Attach File',
            YoutubeLink: 'Attach Youtube',
            NarchivesLink: 'Attach National Archives',
            FigJamLink: 'Attach FigJam',
            GdriveLink: 'Attach Google Drive',
            CanvaLink: 'Attach Canva',
            ViewPreview: 'View Preview',
            ClosePreview: 'Close Preview',

            ChangeDescription: 'Change your full name or your profile image.',
            ProfileImage: 'Profile Image',
            ChangeHandle: '@ Name',
            ChangeHandlePlaceholder: 'Name (without @, without spaces)',

            JoinByCode: 'Join By Code',
            CreateNew: 'Create New',
            RelatedVideos: 'Related Videos',
            RelatedArticles: 'Related Articles',
            NoResults: 'No results',

            PremiumTitle: 'Unlock Premium',
            PremiumDescription: 'Unlock the most powerful AI workflow tools that save you hours of work, create entire lessons out of your prompts, and supercharge engagement',
            Upgrade: 'Unlock for $12 / Month',
            UpgradeYearly: 'Unlock for $99 / Year',
            UpgradeEducator: 'Unlock for $6 / Month',
            UpgradeYearlyEducator: 'Unlock for $58 / Year',
            YouArePremium: 'You are Premium',
            PremiumThankYou: 'thank you for being a',
            Monthly: 'Monthly',
            Yearly: 'Yearly',
            PremiumMember: 'Gravity Premium Member',
            NextRenewal: 'Next Renewal',
            EducatorDiscount: 'Save 50%',
            Savings: 'Save 30%',
            SavingsEducator: 'Save 60%',
            ContactUs: 'Contact Us',
            IAmEducator: 'I am a K-12 Educator! (50% Discount)',

            Yay: 'Yay!',
            Prompt: 'Prompt',
            Response: 'Response',
            Created: 'Created!',
            OnYourWay: 'You\'re now on your way to exciting collaboration!',
            Notify: 'Send Notifications',
            Return: 'Return',
            NotifyAll: 'Notify all',
            MembersOf: 'members of',

            AIPromptAssistant: 'AI Prompt Assistant',
            PromptScript: 'Prompt Script',
            PromptScriptPlaceholder: 'Paste your script here. This area will not be recorded.',
            Hide: 'Hide',
            Show: 'Show',
            Update: 'Update',
            Private: 'Private',
            New: 'New',

            Transcript: 'Transcript',
            Translation: 'Translation',
            SharePublic: 'Share Publicly',
            Next: 'Next',
            HeyThere: 'Hey there',
            FollowUpText: 'Based on your last response, I have a follow-up question for you',

            Leave: 'Leave',
            RecordEmbed: 'Recorder Embed Code',
            AllowPublic: 'Allow public responses to this prompt from anywhere',
            CopyCode: 'Copy Code',
            Copied: 'Copied!',

            Participants: 'Participants',
        },
        Content: {
            JoinCode: 'Join Code',
            Welcome: 'Welcome',
            NoUpdates: 'No updates since your last login',
            CreateASpace: 'Create New Video',

            CreateNewPrompt: 'Create New Prompt',
            CreateSpaceDescription: 'Record your face, voice or screen and get things started. Add information to help others collaborate!',
            CreateSpaceName: 'Prompt Title (Required)',
            CreateSpacePlaceholder: 'ex. Discussion on the Age of Enlightenment',
            ResponseTitle: 'Response Title (Required)',

            NoPromptsYet: 'No prompts yet...',
            SelectAFolder: 'Select a Folder',

            Back: 'Back'
        },
        Recorder: {
            Video: 'Video',
            Screen: 'Screen',
            Voice: 'Voice',
            Combo: 'Combo',
            Upload: 'Upload',
            Resume: 'RESUME',
            Pause: 'PAUSE',
            Recording: 'RECORDING',

            Beta: 'BETA',
            New: 'NEW',

            Speaking: 'Speaking',
            Originality: 'Originality',
            Tone: 'Tone',
            Neutral: 'Neutral',
            Positive: 'Positive',
            Negative: 'Negative',

            FollowUp: 'Follow-Up Question',
            QuestionType: 'Question Type',

            InfoHover: 'Gravity leverages technology to detect responses by generative AI like ChatGPT. (This is an experimental feature)',
            ToneHover: 'Gravity leverages technology to help detect tone based on video transcript. (This is an experimental feature)',
            FollowUpHover: 'Leverage Gravity AI to create a personalized follow-up question following a response.',
            QuestionTypeHover: 'Select the style of the individualized follow-up question following a response.',

            PublishDate: 'Publish Date',
        },
        SpacesView: {
            Conversation: 'Conversation',
            Poll: 'Poll',
            Members: 'Members',
            Joined: 'Joined',
            Anonymous: 'Anonymous',
            ScheduledFor: 'Scheduled for',
            View: 'View',
            Hide: 'Hide',
            Response: 'Response',
            Responses: 'Responses',
        },
        AssetsView: {
            Teacher: 'Teacher',
            Student: 'Student',
            Respond: 'Respond',
            To: ' to',
            RespondTo: 'Respond to',
            DocumentAttachment: 'Document',
            YoutubeAttachment: 'YouTube',
            NarchivesAttachment: 'National Archives',
            NoResponses: 'No responses yet',
            View: 'View',
            Reply: 'Reply',
            Replies: 'Replies',

            ResponseDescriptionPlaceholder: 'ex. Before we make a decision...',
            SidebarWith: 'Sidebar with',
            ThreadDescriptionPlaceholder: 'ex. Could you expand on that detail a bit...',

            Back: 'Back to',
            Keywords: 'Keywords',
            Insights: 'Insights',
            EditKeywords: 'Edit Keywords',
            EditKeywordsDescription: 'Please keep a minimum of 5 keywords',

            Settings: 'Prompt Settings',
            SettingsDescription: 'Control the features of your prompt, edit the publish date, and more.',
            Record: 'Record',
            Text: 'Text',

            AIGenerated: 'AI-Generated Follow-Up Question',
            ClickFor: 'Click for',

            SorryVideo: 'Sorry, the media is not loading...',
            Retry: 'Retry',

            AssessmentText: 'AI Conversation Assessment',
            GeneratingAssessment: 'Generating Assessment...',
        },
        ThreadView: {
            Collapse: 'Collapse',
            Back: 'Back to prompt',
            TypeResponse: 'Type a response...',
            Submitted: 'Sent!',
            Failed: 'Fail',
        },
        Upload: {
            DropFileHere: 'Drop file here',
            Or: 'OR',
            SelectFile: 'Select file',
            SelectVideo: 'Select .mp4',
            SetAsVideo: 'Set As Video',
            FileName: 'File Name',
            FileType: 'File Type',
            Reselect: 'Reselect'
        },
        Video: {
            Transcripts: '*Transcripts are automatically generated. Inaccuracies may occur.',
            Select: 'Select',
            English: 'English',
            Spanish: 'Spanish',
            French: 'French',
            German: 'German',
            Italian: 'Italian',
            Portuguese: 'Portuguese',
            Dutch: 'Dutch',
            Russian: 'Russian',
            Chinese: 'Chinese',
            Japanese: 'Japanese',
            Korean: 'Korean',
            Arabic: 'Arabic',
            Hindi: 'Hindi'
        },
        Embed: {
            PoweredBy: 'Powered by',
            JoinConversation: 'Join This Conversation',
            EnterDetails: 'Enter details below',
            BackGuest: 'Back to Guest Login',
            OrUse: 'or use your',
            ToGetStarted: 'to get started!',
            Name: 'Name',
            Email: 'Email',
            StartRecording: 'Start Recording',
            Success: 'Success!',
            StayTuned: 'Stay tuned for more WRAD prompts!',
            VisitGravity: 'Visit usegravity.io for more collaboration!',
            Sorry: 'Sorry, this prompt is not embeddable',
        }
    },
    zh: {
        Marketing: {
            LogIn: '登录',

            HeroTitle: '记录、反思、回应!',
            HeroDescriptionBold: "世界第一的视频提示录音机",
            HeroDescription: "通过人工智能转录、翻译、个性化跟进、个性化评估等。",

            AIAssistedDiscussions: "即时讨论",
            AIAssistedDiscussionsDescription: "直接在浏览器中录制！添加附件并邀请全班参与。",
            AIAssistedDiscussionsDescription2: "通过 AI 转录、多语种翻译和自动评估点燃无障碍学习。",

            WatchHow: "观看 Gravity 的工作方式",

            KeywordsInsights: "赋予每个声音力量",
            KeywordsInsightsDescription: "智能提取并定义口语关键词，为每位学生提供思维公平。",
            KeywordsInsightsDescription2: "自动生成深入的理解评估，并对同伴之间的互动进行评分。",

            DifferentiatedLearning: "差异化学习",
            DifferentiatedLearningDescription: "为每位学生量身定制个性化的学习路径。",
            DifferentiatedLearningDescription2: "通过创新方式表达理解，灵活调整教学策略。",

            CallOut: "符合 COPPA、FERPA 和 GDPR 要求",
            CallOut2: "无需 RFP。欢迎咨询我们的互助协议。",

            ThoughtEquity: '思想平等',
            ThoughtEquityDescription: 'Gravity提供了时间和空间来给出深思熟虑的答案。 没有弹出式测验响应，没有竞赛举手-每个人都有机会表达自己独特的观点。 创造多元化的观点比以往任何时候都更重要。',
            ResearchBacked: '研究支持',
            ResearchBackedDescription: 'Gravity被约翰霍普金斯大学教育学院选为定量研究，并发现其显着提高了学习成果。',
            ByEducators: '由教育工作者制作，供教育工作者使用',
            ByEducatorsDescription: 'Gravity由一组教师、教授和技术人员构建，他们相信教育的力量可以改变世界。',
            MagicAIPrompts: 'Premium提示',
            UnlimitedRecording: '无限录制',
            AIVoiceToneAnalysis: '立即将视频配音成 12 种以上的世界语言！',
            ReadyToSupercharge: '准备为您的课堂提速吗？',
            YesIAm: '是的，我是 - 让我们走！',
            StartForFree: '免费开始！',
            StartForFreeDescription: '在承诺之前，立即开始使用我们的免费版本',
            StartForFreeCallout: '无需信用卡',
            AffordablePricing: '实惠的定价',
            AffordablePricingDescription: '创建社区既简单又实惠。 从每月6美元的录制计划开始免费。',
            AffordablePricingCallout: '年度优惠30％！',
            Privacy: '隐私政策',
            TOS: '服务条款'
        },
        Header: {
            Logout: '登出',
            EditProfile: '编辑个人资料',
            MonthlyRecordingLimit: '每月录制限制',
            MinutesRemaining: '剩余分钟',
            New: '新',
            ComingSoon: '即将推出',
            BrandNewPricing: 'Gravity 4.0',
            ComingApril: '新定价 + AI 评估！',
            IsHere: '在这里',
            VoiceOverText: '立即将任何Premium提示讨论瞬间翻译和配音成多种语言',
            FollowUpText: '根据您的回答回答由 AI 生成的个性化后续问题',
        },
        Register: {
            Greeting: '你好',
            GetRegistered: '让我们注册',
            HaveJoinCode: '我有一个加入代码',
            CreateCommunity: '创建一个新社区',
            JoinCode: '加入代码',
            NewCommunity: '新社区',
            SixCode: '请输入您的6位字符代码',
            CommunityName: '您想给社区起什么名字？',
            CreateAccount: '创建帐号',
            ToJoin: '加入',
            ThisCommunity: '这个社区',
            ToStart: '开始',
            YourCommunity: '你的社区',
            Now: '现在'
        },
        Dashboard: {
            BookDemo: '免费预订 Gravity 15 分钟现场演示!',
            Dashboard: '仪表板',
            Watched: '已观看',
            Videos: '视频',
            Created: '创建',
            Recordings: '录音',
            Responded: '已回复',
            Conversations: '对话',
            CreatorStudio: '创作者工作室',
            QuickPrompt: '快速提示',
            MagicAIPrompt: '记录提示',
            MagicAI: 'Gravity AI',
            Left: '剩余',
            Unlock: '解锁',
            RecentVideos: '最近的视频',
            Engagement: '参与度',
            QuickMenu: '快速菜单',
            CheckMirror: '检查镜像',
            Tutorials: '教程',
            TutorialsDescription: '教程和知识，专为您而设',
            BackToDashboard: '返回仪表板',
            BackToTutorials: '返回教程',
        },
        Search: {
            NoResults: '没有结果',
            Create: '创建'
        },
        LoginRegister: {
            EmailAddress: '电子邮件地址',
            Password: '密码',
            Login: '登录',
            Register: '登记',
            FullName: '全名',
            FullNamePlaceholder: '晓明',
            CommunitySearch: '社区搜索',
            CommunitySearchPlaceholder: '搜索社区',
            CheckAvailability: '检查可用性',
            AccountType: '我是',
            Uppercase: '大写字母',
            Lowercase: '小写字母',
            Number: '数字',
            SpecialCharacter: '特殊字符',
            MinimumCharacters: '最少字符',
            RestoringSession: '恢复会话...',
            LogInToGravity: '登录Gravity',
            NewToGravity: '刚接触Gravity？',
            ForgotPassword: '忘记密码？',
            Request: '要求',
            GoBack: '回去',
            RequestSent: '请求已发送',
            Continue: '继续'
        },
        Package: {
            Basic: '基本',
            RecordAndShare: '录制+分享',
            Free: '免费',
            Includes: '包括',
            ThirtyMin: '30分钟共享录制限制',
            Community: '社区',
            Folders: '文件夹',
            GetStarted: '开始',
            Basic: '基本的',
            Premium: '高级',
            Unlimited: '无限',
            UnlimitedEverything: '无限一切',
            AIWorkflows: 'AI工作流',
            PerMonth: '每月',
            EverythingInBasicPlus: '基本功能加上',
            UnlimitedRecordingLimit: '无限录制限制',
            UnlimitedCommunities: '无限社区',
            UnlimitedFolders: '无限文件夹',
            AIVoiceToneAnalysis: 'AI语音翻译',
            AIAutoTranscription: 'AI自动转录',
            AIKeywordsAndInsights: 'AI关键字和见解',
            StartNow: '现在开始',
            Enterprise: '企业',
            AdminAndAnalytics: '管理+分析',
            Custom: '习惯',
            EverythingInPremiumPlus: '高级版中的所有内容，加上',
            AnalyticsAndUsage: '分析和使用情况',
            DocumentAttachments: '文档附件',
            DocumentAttachmentsDescription: '附加文档和Youtube视频以提供更多上下文！',
            MonthlyEngagementReports: '每月参与报告',
            DedicatedAccountManager: '专属客户经理',
            TwentyFourSevenSupport: '24/7支持',
            LetsTalk: '让我们谈谈',
            OneMinuteRecordingLimit: '1分钟录制限制',
            UnlimitedMagicAIPrompts: '无限PremiumI提示',
            UnlimitedMagicAIPromptsDescription: 'Gravity提示通过单个录音创建整个课程',
            UnlimitedRecordingLimitDescription: '无限制地录制任何内容',
            AIVoiceToneAnalysisDescription: '立即按需将视频翻译并配音成 12 种以上的世界语言！',
            AIAutoTranscriptionDescription: '提高可访问性、参与度和学习成果',
            AIKeywordsAndInsightsDescription: '关键字提取、即时定义和建议内容',
            AnalyticsAndUsageDescription: '详细的报告使用情况、参与度、什么有效、什么无效',
            MagicAIPrompts: 'Premium提示',
            UnlimitedRecording: '无限录制',
        },
        Pricing: {
            Basic: '基本',
            BasicPrice: '免费',
            BasicDetails: 'K-12教育工作者无限参与者',
            StartCreating: '参与、录制和分享',
            RecordAnswerPrompts: '记录和回答提示',
            CreateCommunities: '创建社区',
            CreateNumberCommunities: '创建多达1个社区',
            CreateTwentyFiveParticipants: '邀请多达25名参与者',
            RecordUnlimitedPrompts: '<span className="unlimited">无限</span>提示录制',
            OneMinuteRecordingTime: '1分钟录制时间/提示',
            StartNow: '开始基本',
            Premium: '高级',
            PremiumPrice: '$12/月',
            PremiumDetails: 'K-12教育工作者50%折扣',
            AttachmentAIMore: 'AI、附件和更多',
            CreateUnlimitedCommunities: '<span className="unlimited">无限</span>社区创建',
            InviteUnlimitedParticipants: '<span className="unlimited">无限</span>参与者邀请',
            UnlimitedRecordingTime: '<span className="unlimited">无限</span>录制时间/提示',
            AttachDocumentsVideos: '<span className="unlimited">附加</span>文档、图像和视频',
            AIPoweredFeatures: '<span className="unlimited">AI驱动</span>创建工作流',
            CreateNow: '开始高级',
            District: '您是地区还是机构',
            ContactPricing: '联系我们获取定价',
        },
        Menu: {
            Select: '选择',
            Create: '创建',
            CommunityBegin: '一个社区开始.',
            Communities: '社区',
            Folders: '文件夹',

            AddCommunity: '添加社区',
            AddCommunityDescription: '加入或建立下一个供人们协作、交谈和探索下一步的好地方。 使用 Gravity 将人们带到同一张桌子旁。',
            AddCommunityNotAllowed: '加入或建立下一个供人们协作、交谈和探索下一步的好地方。 要创建新社区，请升级到高级版。',
            AddCommunityName: '社区名字',
            AddCommunityPlaceholder: '例如: DEJ073',
            CreateCommunityPlaceholder: '例如: 桑树街学校',

            AddJoinCode: '输入加入密码',
            AddJoinCodeDescription: '加入您的同学社区进行协作、交谈并探索下一步.',
            AddJoinCodeName: '加入代码',
            AddJoinCodePlaceholder: '例如: 0XF78D',

            CreateFolder: '创建一个文件夹',
            CreateFolderDescription: '将社区中的人们聚集到集中的小组中讨论任何事情。 建立协作对话、投票等。',
            CreateFolderName: '文件夹名称',
            CreateFolderPlaceholder: '例如: 欧洲历史课',

            ConfirmDelete: '删除文件夹',
            ConfirmDeleteDescription: '你确定你要删除',
            ConfirmDeleteDiscussion: '删除讨论',
            ConfirmDeleteResponse: '删除回复',
            ConfirmDeleteBackground: '删除背景',
            ConfirmDeleteBackgroundDescription: '您确定要删除该背景吗?',

            ConfirmRemoveMember: '移除成员',
            ConfirmRemoveMemberDescription: '您确定要移除',
            ConfirmRemoveMemberDescription2: '吗',

            CreateFolderStart: '创建文件夹以开始协作',
            Duplicate: '复制',
            ConfirmDuplicate: '重复文件夹',
            ConfirmDuplicateDescription: '将在没有响应的情况下重复。 请为新文件夹输入唯一的名称。',
            UniqueName: '独特的名字',

            InviteMembers: '邀请成员',
            InviteMembersDescription: '输入您要邀请到您的社区的电子邮件地址。',
            InviteMembersPlaceholder: 'example@email.com',
            InviteButton: '发送邀请',
            InviteSent: '发送',

            EditCommunities: '编辑社区',
            EditCommunitiesDescription: '重命名、删除或复制您的社区。',

            EditFolders: '编辑文件夹',
            EditFoldersDescription: '重命名、删除或复制您的文件夹。',
        },
        Modal: {
            Cancel: '取消',
            Submit: '提交',
            Remove: '消除',
            SubmitContinue: '提交并继续',
            Loading: '加载中',
            Uploading: '上传',
            Close: '关闭',
            ShortDescription: '提示描述(必需的)',
            ShortDescriptionPlaceholder: '例如: 请讲两分钟关于...',
            SpaceType: '空间类型',
            Conversation: '对话',
            ConversationDescription: '对话让您可以随时记录、回复和与同学协作。',
            Poll: '轮询',
            PollDescription: '准备好权衡选择或达成共识了吗？ 发起民意调查，让社区发言。',
            VideoRecording: '视频录制',
            AttachFile: '附加文件',
            YoutubeLink: 'YouTube网址',
            NarchivesLink: '国家档案馆链接',
            FigmaLink: 'FigJam链接',
            GdriveLink: 'Google Drive链接',
            CanvaLink: 'Canva链接',
            ViewPreview: '查看预览',
            ClosePreview: '关闭预览',

            ChangeDescription: '更改您的全名或个人资料图片。',
            ProfileImage: '个人资料图片',
            ChangeHandle: '@ 名字',
            ChangeHandlePlaceholder: '名字 (没有@, 没有空间)',

            JoinByCode: '加入代码',
            CreateNew: '创建新的',
            RelatedVideos: '有关的影片',
            RelatedArticles: '有关的文章',
            NoResults: '没有结果',

            PremiumTitle: '升级到高级版',
            PremiumDescription: '即可解锁最强大的 AI 工作流工具，可节省您数小时的工作时间，通过自动建议创建整个课程，并大大提高参与度',
            Upgrade: '解锁 $12 / 月',
            UpgradeYearly: '解锁 $99 / 年',
            UpgradeEducator: '解锁 $6 / 月',
            UpgradeYearlyEducator: '解锁 $58 / 年',
            YouArePremium: '您是高级版',
            PremiumThankYou: '感谢您成为',
            Monthly: '每月',
            Yearly: '每年',
            PremiumMember: 'Gravity高级会员。',
            NextRenewal: '下次续订',
            EducatorDiscount: '50% 折扣',
            Savings: '30% 折扣',
            SavingsEducator: '60% 折扣',
            ContactUs: '联系我们',
            IAmEducator: '我是 K-12 教育工作者！ (50% 折扣)',

            Yay: '耶!',
            Prompt: '提示',
            Response: '空间',
            Created: '创建!',
            OnYourWay: '您现在正在进行令人兴奋的协作!',
            Notify: '发送通知',
            Return: '返回',
            NotifyAll: '通知所有',
            MembersOf: '的成员',

            AIPromptAssistant: 'AI提示助手',
            PromptScript: '提示脚本',
            PromptScriptPlaceholder: '在这里粘贴您的脚本。 此区域不会被记录。',
            Hide: '隐藏',
            Show: '显示',
            Update: '更新',
            Private: '私人',
            New: '新',

            Transcript: '记录',
            Translation: '翻译',
            SharePublic: '分享公开',
            Next: '下一个',
            HeyThere: '你好呀',
            FollowUpText: '根据你上次的回复，我有一个后续问题要问你',

            Leave: '离开',
            RecordEmbed: '录音机嵌入代码',
            AllowPublic: '允许从任何地方公开回应此提示',
            CopyCode: '复制代码',
            Copied: '已复制!',

            Participants: '参与者',
        },
        Content: {
            JoinCode: '加入代码',
            Welcome: '欢迎',
            NoUpdates: '自您上次登录以来没有更新',
            CreateASpace: '创造新空间',

            CreateNewPrompt: '创建新提示',
            CreateSpaceDescription: '录制您的面部、声音或屏幕，然后开始工作。 添加信息以帮助其他人协作!',
            CreateSpaceName: '提示标题(必需的)',
            CreateSpacePlaceholder: '例如: 启蒙时代的探讨',
            ResponseTitle: '回复标题(必需的)',

            NoPromptsYet: '还没有提示',
            SelectAFolder: '选择一个文件夹',

            Back: '返回'
        },
        Recorder: {
            Video: '视频',
            Screen: '屏幕',
            Voice: '语音',
            Combo: '组合',
            Upload: '上传',
            Resume: '恢复',
            Pause: '暂停',
            Recording: '记录的',

            Beta: '测试版',
            New: '新的',

            Speaking: '发言',
            Originality: '独创性',
            Tone: '笔调',
            Neutral: '中性',
            Positive: '正面',
            Negative: '负面',

            FollowUp: '跟进问题',
            QuestionType: '问题类型',

            InfoHover: 'Gravity利用技术来检测生成AI的响应,例如ChatGPT. (这是一个实验性功能)',
            ToneHover: 'Gravity 利用技术帮助检测基于视频转录的音调. (这是一个实验性功能)',
            FollowUpHover: '利用 Gravity AI 在回复后创建个性化的后续问题。',
            QuestionTypeHover: '选择答复后的个性化后续问题的样式。',

            PublishDate: '发布日期',
        },
        SpacesView: {
            Conversation: '对话',
            Poll: '轮询',
            Members: '成员',
            Joined: '已加入',
            Anonymous: '匿名',
            ScheduledFor: '计划于',
            View: '查看',
            Hide: '隐藏',
            Response: '回应',
            Responses: '回应',
        },
        AssetsView: {
            Teacher: '老师',
            Student: '学生',
            Respond: '回复',
            To: '',
            RespondTo: '回复',
            DocumentAttachment: '文件附件',
            YoutubeAttachment: 'YouTube附件',
            NarchivesAttachment: '国家档案馆附件',
            NoResponses: '还没有回复',
            View: '查看',
            Reply: '回复',
            Replies: '个回复',

            ResponseDescriptionPlaceholder: '例如: 在我们做出决定之前...',
            SidebarWith: '侧边栏',
            ThreadDescriptionPlaceholder: '例如: 你能把这个细节扩展一下吗...',

            Back: '返回',
            Keywords: '关键词',
            Insights: '更多信息',
            EditKeywords: '编辑关键词',
            EditKeywordsDescription: '请保留至少5个关键字',

            Settings: '提示设置',
            SettingsDescription: '控制提示的功能，编辑发布日期等。',
            Record: '记录',
            Text: '文本',

            AIGenerated: 'AI生成的后续问题',
            ClickFor: '点击查看',

            SorryVideo: '抱歉，媒体未加载...',
            Retry: '重试',

            AssessmentText: 'AI对话评估',
            GeneratingAssessment: '生成评估...',
        },
        ThreadView: {
            Collapse: '关闭',
            Back: '返回提示',
            TypeResponse: '输入回复...',
            Submitted: '发送!',
            Failed: '失败的',
        },
        Upload: {
            DropFileHere: '把文件放在这里',
            Or: '或',
            SelectFile: '选择文件',
            SelectVideo: '选择.mp4',
            SetAsVideo: '设置为视频',
            FileName: '文件名',
            FileType: '文件类型',
            Reselect: '重新选择'
        },
        Video: {
            Transcripts: '*记录是自动生成的。 可能会出现不准确的情况。',
            Select: '选择',
            English: '英语',
            Spanish: '西班牙语',
            French: '法语',
            German: '德语',
            Italian: '意大利语',
            Portuguese: '葡萄牙语',
            Dutch: '荷兰语',
            Russian: '俄语',
            Chinese: '中文',
            Japanese: '日语',
            Korean: '韩语',
            Arabic: '阿拉伯语',
            Hindi: '印地语'
        },
        Embed: {
            PoweredBy: '供電',
            JoinConversation: '加入此對話',
            EnterDetails: '在下面输入详细信息',
            BackGuest: '返回访客登录',
            ToGetStarted: '开始！',
            OrUse: '或使用您的',
            Name: '名字',
            Email: '电子邮件',
            StartRecording: '开始录制',
            Success: '已连接!',
            StayTuned: '请继续关注更多WRAD提示!',
            VisitGravity: '访问 usegravity.io 获得更多合作!',
            Sorry: '抱歉，此提示不可嵌入',
        }
    },
    ja: {
        Marketing: {
            LogIn: 'ログイン',

            HeroTitle: '記録し、反映する、応答し!',
            HeroDescriptionBold: "世界No.1のビデオプロンプトレコーダー",
            HeroDescription: "AI を活用した文字起こし、翻訳、パーソナライズされたフォローアップ、個別評価など。",

            AIAssistedDiscussions: "インスタントディスカッション",
            AIAssistedDiscussionsDescription: "ブラウザで直接録画！資料を追加してクラス全体を招待しよう。",
            AIAssistedDiscussionsDescription2: "AIによる文字起こし、多言語翻訳、自動評価で誰もがアクセスできる学びを実現。",

            WatchHow: "Gravity の使い方を見る",

            KeywordsInsights: "すべての声に力を与える",
            KeywordsInsightsDescription: "口頭で話されたキーワードを自動的に抽出・定義し、すべての生徒に思考の平等を提供します。",
            KeywordsInsightsDescription2: "理解度の深い評価を自動生成し、生徒同士のやり取りをスコア化。",

            DifferentiatedLearning: "個別最適化学習",
            DifferentiatedLearningDescription: "生徒一人ひとりの学習スタイルに合わせた個別の学習ルートを作成。",
            DifferentiatedLearningDescription2: "理解を表現する革新的な方法で、指導法を多様化。",

            CallOut: "COPPA、FERPA、GDPR 準拠",
            CallOut2: "RFPは不要です。相互契約についてお問い合わせください。",

            ThoughtEquity: '思考の平等性',
            ThoughtEquityDescription: 'Gravityは熟考された回答をするための時間と空間を提供します。ポップアップクイズの回答や手を挙げる競争はなく、誰もが自分独自の視点を表現する機会があります。多様な視点を生み出すことはこれまで以上に重要です。',
            ResearchBacked: '研究に裏付けられた',
            ResearchBackedDescription: 'Gravityはジョンズ・ホプキンス大学教育学部による定量研究に選ばれ、学習成果を著しく向上させることが判明しました。',
            ByEducators: '教育者によって作られ、教育者のために',
            ByEducatorsDescription: 'Gravityは、教育の力が世界を変えることができると信じる教師、教授、技術者のグループによって構築されました。',
            MagicAIPrompts: 'プレミアムプロンプト',
            UnlimitedRecording: '無制限録画',
            AIVoiceToneAnalysis: '12カ国語以上の世界言語に即座に吹き替え！',
            ReadyToSupercharge: 'あなたの授業に活力を与える準備はできていますか？',
            YesIAm: 'はい、始めましょう！',
            StartForFree: '無料で始める！',
            StartForFreeDescription: 'コミットする前に、今すぐ無料版で始めましょう',
            StartForFreeCallout: 'クレジットカード不要',
            AffordablePricing: '手頃な価格設定',
            AffordablePricingDescription: 'コミュニティの作成は簡単で手頃です。毎月¥800からの録画プランを無料でお試しください。',
            AffordablePricingCallout: '年間プランで30％オフ！',
            Privacy: 'プライバシーポリシー',
            TOS: '利用規約'
        },
        Header: {
            Logout: 'ログアウト',
            EditProfile: 'プロフィール編集',
            MonthlyRecordingLimit: '月間録画制限',
            MinutesRemaining: '残り分数',
            New: '新着',
            ComingSoon: '近日公開',
            BrandNewPricing: 'Gravity 4.0',
            ComingApril: '新しい価格設定 + AI 評価！',
            IsHere: '登場',
            VoiceOverText: 'プレミアムプロンプトディスカッションを複数の言語に即座に翻訳・吹き替え',
            FollowUpText: 'あなたの回答に基づいてAIが生成したパーソナライズされたフォローアップ質問に答える',
        },
        Register: {
            Greeting: 'こんにちは',
            GetRegistered: '登録しましょう',
            HaveJoinCode: '参加コードを持っています',
            CreateCommunity: '新しいコミュニティを作成',
            JoinCode: '参加コード',
            NewCommunity: '新しいコミュニティ',
            SixCode: '6文字のコードを入力してください',
            CommunityName: 'コミュニティの名前を何にしますか？',
            CreateAccount: 'アカウント作成',
            ToJoin: '参加する',
            ThisCommunity: 'このコミュニティに',
            ToStart: '始める',
            YourCommunity: 'あなたのコミュニティを',
            Now: '今すぐ'
        },
        Dashboard: {
            BookDemo: 'Gravityの15分無料デモを予約！',
            Dashboard: 'ダッシュボード',
            Watched: '視聴済み',
            Videos: 'ビデオ',
            Created: '作成済み',
            Recordings: '録画',
            Responded: '回答済み',
            Conversations: '会話',
            CreatorStudio: 'クリエイタースタジオ',
            QuickPrompt: 'クイックプロンプト',
            MagicAIPrompt: '録画プロンプト',
            MagicAI: 'Gravity AI',
            Left: '残り',
            Unlock: 'アンロック',
            RecentVideos: '最近のビデオ',
            Engagement: 'エンゲージメント',
            QuickMenu: 'クイックメニュー',
            CheckMirror: 'ミラーチェック',
            Tutorials: 'チュートリアル',
            TutorialsDescription: 'あなたのためのチュートリアルとナレッジ',
            BackToDashboard: 'ダッシュボードに戻る',
            BackToTutorials: 'チュートリアルに戻る',
        },
        Search: {
            NoResults: '結果なし',
            Create: '作成'
        },
        LoginRegister: {
            EmailAddress: 'メールアドレス',
            Password: 'パスワード',
            Login: 'ログイン',
            Register: '登録',
            FullName: '氏名',
            FullNamePlaceholder: '田中太郎',
            CommunitySearch: 'コミュニティ検索',
            CommunitySearchPlaceholder: 'コミュニティを検索',
            CheckAvailability: '利用可能か確認',
            AccountType: '私は',
            Uppercase: '大文字',
            Lowercase: '小文字',
            Number: '数字',
            SpecialCharacter: '特殊文字',
            MinimumCharacters: '最小文字数',
            RestoringSession: 'セッションを復元中...',
            LogInToGravity: 'Gravityにログイン',
            NewToGravity: 'Gravityは初めてですか?',
            ForgotPassword: 'パスワードをお忘れですか？',
            Request: 'リクエスト',
            GoBack: '戻る',
            RequestSent: 'リクエスト送信済み',
            Continue: '続ける'
        },
        Package: {
            Basic: 'ベーシック',
            RecordAndShare: '録画+共有',
            Free: '無料',
            Includes: '含まれるもの',
            ThirtyMin: '共有録画30分制限',
            Community: 'コミュニティ',
            Folders: 'フォルダ',
            GetStarted: '始める',
            Basic: '基本',
            Premium: 'プレミアム',
            Unlimited: '無制限',
            UnlimitedEverything: 'すべて無制限',
            AIWorkflows: 'AIワークフロー',
            PerMonth: '月額',
            EverythingInBasicPlus: 'ベーシックの全機能に加えて',
            UnlimitedRecordingLimit: '録画制限なし',
            UnlimitedCommunities: 'コミュニティ無制限',
            UnlimitedFolders: 'フォルダ無制限',
            AIVoiceToneAnalysis: 'AI音声翻訳',
            AIAutoTranscription: 'AI自動文字起こし',
            AIKeywordsAndInsights: 'AIキーワードと洞察',
            StartNow: '今すぐ始める',
            Enterprise: 'エンタープライズ',
            AdminAndAnalytics: '管理+分析',
            Custom: 'カスタム',
            EverythingInPremiumPlus: 'プレミアムの全機能に加えて',
            AnalyticsAndUsage: '分析と使用状況',
            DocumentAttachments: '資料添付',
            DocumentAttachmentsDescription: 'より多くのコンテキストを提供するために資料やYouTube動画を添付！',
            MonthlyEngagementReports: '月間エンゲージメントレポート',
            DedicatedAccountManager: '専任アカウントマネージャー',
            TwentyFourSevenSupport: '24時間365日サポート',
            LetsTalk: 'お問い合わせ',
            OneMinuteRecordingLimit: '1分録画制限',
            UnlimitedMagicAIPrompts: '無制限プレミアムプロンプト',
            UnlimitedMagicAIPromptsDescription: '単一の録音で完全なコースを作成するGravityプロンプト',
            UnlimitedRecordingLimitDescription: '無制限に何でも録画',
            AIVoiceToneAnalysisDescription: '12カ国語以上の世界言語に即座に翻訳・吹き替え！',
            AIAutoTranscriptionDescription: 'アクセシビリティ、エンゲージメント、学習成果を向上',
            AIKeywordsAndInsightsDescription: 'キーワード抽出、即時定義、推奨コンテンツ',
            AnalyticsAndUsageDescription: '使用状況、エンゲージメント、効果的なもの、効果的でないものの詳細レポート',
            MagicAIPrompts: 'プレミアムプロンプト',
            UnlimitedRecording: '無制限録画',
        },
        Pricing: {
            Basic: 'ベーシック',
            BasicPrice: '無料',
            BasicDetails: 'K-12教育者向け無制限参加者',
            StartCreating: '参加、録画、共有を始める',
            RecordAnswerPrompts: 'プロンプトの記録と回答',
            CreateCommunities: 'コミュニティ作成',
            CreateNumberCommunities: '最大1つのコミュニティ作成',
            CreateTwentyFiveParticipants: '最大25人の参加者を招待',
            RecordUnlimitedPrompts: '<span className="unlimited">無制限</span>プロンプト録画',
            OneMinuteRecordingTime: 'プロンプト1分録画時間',
            StartNow: 'ベーシックを始める',
            Premium: 'プレミアム',
            PremiumPrice: '¥1,500/月',
            PremiumDetails: 'K-12教育者50%割引',
            AttachmentAIMore: 'AI、添付ファイルなど',
            CreateUnlimitedCommunities: '<span className="unlimited">無制限</span>コミュニティ作成',
            InviteUnlimitedParticipants: '<span className="unlimited">無制限</span>参加者招待',
            UnlimitedRecordingTime: '<span className="unlimited">無制限</span>録画時間/プロンプト',
            AttachDocumentsVideos: '<span className="unlimited">添付</span>資料、画像、動画',
            AIPoweredFeatures: '<span className="unlimited">AI駆動</span>クリエイティブワークフロー',
            CreateNow: 'プレミアムを始める',
            District: '教育委員会または機関ですか',
            ContactPricing: '価格についてお問い合わせ',
        },
        Menu: {
            Select: '選択',
            Create: '作成',
            CommunityBegin: 'コミュニティから始める。',
            Communities: 'コミュニティ',
            Folders: 'フォルダ',

            AddCommunity: 'コミュニティを追加',
            AddCommunityDescription: '人々が協力し、会話し、次のステップを探索するための素晴らしい場所に参加または構築します。Gravityを使用して人々を同じテーブルに集めましょう。',
            AddCommunityNotAllowed: '人々が協力し、会話し、次のステップを探索するための素晴らしい場所に参加または構築します。新しいコミュニティを作成するには、プレミアムにアップグレードしてください。',
            AddCommunityName: 'コミュニティ名',
            AddCommunityPlaceholder: '例: DEJ073',
            CreateCommunityPlaceholder: '例: 桜町学園',

            AddJoinCode: '参加コードを入力',
            AddJoinCodeDescription: 'クラスメイトのコミュニティに参加して、協力し、会話し、次のステップを探索しましょう。',
            AddJoinCodeName: '参加コード',
            AddJoinCodePlaceholder: '例: 0XF78D',

            CreateFolder: 'フォルダを作成',
            CreateFolderDescription: 'コミュニティ内の人々を集中的なグループに集めて何でも議論しましょう。協力的な会話、投票などを構築します。',
            CreateFolderName: 'フォルダ名',
            CreateFolderPlaceholder: '例: 日本史クラス',

            ConfirmDelete: 'フォルダを削除',
            ConfirmDeleteDescription: '本当に削除しますか',
            ConfirmDeleteDiscussion: 'ディスカッションを削除',
            ConfirmDeleteResponse: '返信を削除',
            ConfirmDeleteBackground: '背景を削除',
            ConfirmDeleteBackgroundDescription: '背景を削除してもよろしいですか？',

            ConfirmRemoveMember: 'メンバーを削除',
            ConfirmRemoveMemberDescription: '本当に削除しますか',
            ConfirmRemoveMemberDescription2: 'さんを',

            CreateFolderStart: 'フォルダを作成して協力を始める',
            Duplicate: '複製',
            ConfirmDuplicate: 'フォルダを複製',
            ConfirmDuplicateDescription: '返信なしで複製されます。新しいフォルダに一意の名前を入力してください。',
            UniqueName: 'ユニークな名前',

            InviteMembers: 'メンバーを招待',
            InviteMembersDescription: 'コミュニティに招待したいメールアドレスを入力してください。',
            InviteMembersPlaceholder: 'example@email.com',
            InviteButton: '招待を送信',
            InviteSent: '送信済み',

            EditCommunities: 'コミュニティを編集',
            EditCommunitiesDescription: 'コミュニティの名前変更、削除、複製。',

            EditFolders: 'フォルダを編集',
            EditFoldersDescription: 'フォルダの名前変更、削除、複製。',
        },
        Modal: {
            Cancel: 'キャンセル',
            Submit: '送信',
            Remove: '削除',
            SubmitContinue: '送信して続ける',
            Loading: '読み込み中',
            Uploading: 'アップロード中',
            Close: '閉じる',
            ShortDescription: 'プロンプトの説明（必須）',
            ShortDescriptionPlaceholder: '例: 〜について2分間話してください...',
            SpaceType: 'スペースタイプ',
            Conversation: '会話',
            ConversationDescription: '会話では、いつでも録画、返信、クラスメイトとの協力が可能です。',
            Poll: '投票',
            PollDescription: '選択肢を検討したり合意を得る準備ができましたか？投票を開始して、コミュニティに発言させましょう。',
            VideoRecording: 'ビデオ録画',
            AttachFile: 'ファイルを添付',
            YoutubeLink: 'YouTubeリンク',
            NarchivesLink: '国立公文書館リンク',
            FigmaLink: 'FigJamリンク',
            GdriveLink: 'Googleドライブリンク',
            CanvaLink: 'Canvaリンク',
            ViewPreview: 'プレビューを表示',
            ClosePreview: 'プレビューを閉じる',

            ChangeDescription: 'フルネームまたはプロフィール画像を変更します。',
            ProfileImage: 'プロフィール画像',
            ChangeHandle: '@ハンドル',
            ChangeHandlePlaceholder: 'ハンドル（@なし、スペースなし）',

            JoinByCode: 'コードで参加',
            CreateNew: '新規作成',
            RelatedVideos: '関連動画',
            RelatedArticles: '関連記事',
            NoResults: '結果なし',

            PremiumTitle: 'プレミアムにアップグレード',
            PremiumDescription: '何時間もの作業時間を節約する最も強力なAIワークフローツールのロックを解除し、自動提案で完全なコースを作成し、エンゲージメントを大幅に向上させます',
            Upgrade: '¥1,500/月でアンロック',
            UpgradeYearly: '¥12,000/年でアンロック',
            UpgradeEducator: '¥750/月でアンロック',
            UpgradeYearlyEducator: '¥7,000/年でアンロック',
            YouArePremium: 'あなたはプレミアムです',
            PremiumThankYou: 'ご利用ありがとうございます',
            Monthly: '月額',
            Yearly: '年額',
            PremiumMember: 'Gravityプレミアムメンバー。',
            NextRenewal: '次回更新',
            EducatorDiscount: '50%割引',
            Savings: '30%割引',
            SavingsEducator: '60%割引',
            ContactUs: 'お問い合わせ',
            IAmEducator: '私はK-12教育者です！（50%割引）',

            Yay: 'やった！',
            Prompt: 'プロンプト',
            Response: 'スペース',
            Created: '作成しました！',
            OnYourWay: 'エキサイティングなコラボレーションへの道を進んでいます！',
            Notify: '通知を送信',
            Return: '戻る',
            NotifyAll: '全員に通知',
            MembersOf: 'のメンバー',

            AIPromptAssistant: 'AIプロンプトアシスタント',
            PromptScript: 'プロンプトスクリプト',
            PromptScriptPlaceholder: 'ここにスクリプトを貼り付けてください。このエリアは録画されません。',
            Hide: '非表示',
            Show: '表示',
            Update: '更新',
            Private: 'プライベート',
            New: '新規',

            Transcript: '文字起こし',
            Translation: '翻訳',
            SharePublic: '公開共有',
            Next: '次へ',
            HeyThere: 'こんにちは',
            FollowUpText: '前回の回答に基づいて、フォローアップの質問があります',

            Leave: '退出',
            RecordEmbed: 'レコーダー埋め込みコード',
            AllowPublic: 'どこからでもこのプロンプトに公開で返信できるようにする',
            CopyCode: 'コードをコピー',
            Copied: 'コピーしました！',

            Participants: '参加者',
        },
        Content: {
            JoinCode: '参加コード',
            Welcome: 'ようこそ',
            NoUpdates: '前回のログイン以降の更新はありません',
            CreateASpace: '新しいスペースを作成',

            CreateNewPrompt: '新しいプロンプトを作成',
            CreateSpaceDescription: '顔、声、または画面を録画して始めましょう。他の人が協力するのに役立つ情報を追加してください！',
            CreateSpaceName: 'プロンプトタイトル（必須）',
            CreateSpacePlaceholder: '例: 江戸時代についての討論',
            ResponseTitle: '返信タイトル（必須）',

            NoPromptsYet: 'まだプロンプトがありません',
            SelectAFolder: 'フォルダを選択',

            Back: '戻る'
        },
        Recorder: {
            Video: 'ビデオ',
            Screen: '画面',
            Voice: '音声',
            Combo: '組み合わせ',
            Upload: 'アップロード',
            Resume: '再開',
            Pause: '一時停止',
            Recording: '録画中',

            Beta: 'ベータ',
            New: '新機能',

            Speaking: '話し方',
            Originality: 'オリジナリティ',
            Tone: 'トーン',
            Neutral: '中立',
            Positive: 'ポジティブ',
            Negative: 'ネガティブ',

            FollowUp: 'フォローアップ質問',
            QuestionType: '質問タイプ',

            InfoHover: 'GravityはChatGPTなどの生成AIによる返答を検出する技術を活用しています。（これは実験的機能です）',
            ToneHover: 'Gravityはビデオの文字起こしに基づいてトーンを検出する技術を活用しています。（これは実験的機能です）',
            FollowUpHover: 'Gravity AIを活用して、返信後にパーソナライズされたフォローアップ質問を作成します。',
            QuestionTypeHover: '返信後のパーソナライズされたフォローアップ質問のスタイルを選択します。',

            PublishDate: '公開日',
        },
        SpacesView: {
            Conversation: '会話',
            Poll: '投票',
            Members: 'メンバー',
            Joined: '参加済み',
            Anonymous: '匿名',
            ScheduledFor: '予定日時',
            View: '表示',
            Hide: '非表示',
            Response: '返信',
            Responses: '返信',
        },
        AssetsView: {
            Teacher: '教師',
            Student: '生徒',
            Respond: '返信',
            To: 'に',
            RespondTo: '返信先',
            DocumentAttachment: '資料添付',
            YoutubeAttachment: 'YouTube添付',
            NarchivesAttachment: '国立公文書館添付',
            NoResponses: 'まだ返信がありません',
            View: '表示',
            Reply: '返信',
            Replies: '件の返信',

            ResponseDescriptionPlaceholder: '例: 決定する前に...',
            SidebarWith: 'サイドバー',
            ThreadDescriptionPlaceholder: '例: この詳細をもう少し説明していただけますか...',

            Back: '戻る',
            Keywords: 'キーワード',
            Insights: '詳細情報',
            EditKeywords: 'キーワードを編集',
            EditKeywordsDescription: '少なくとも5つのキーワードを保持してください',

            Settings: 'プロンプト設定',
            SettingsDescription: 'プロンプトの機能を制御し、公開日などを編集します。',
            Record: '録画',
            Text: 'テキスト',

            AIGenerated: 'AI生成フォローアップ質問',
            ClickFor: 'クリックして表示',

            SorryVideo: '申し訳ありません、メディアが読み込まれませんでした...',
            Retry: '再試行',

            AssessmentText: 'AI対話評価',
            GeneratingAssessment: '評価を生成中...',
        },
        ThreadView: {
            Collapse: '折りたたむ',
            Back: 'プロンプトに戻る',
            TypeResponse: '返信を入力...',
            Submitted: '送信しました！',
            Failed: '失敗しました',
        },
        Upload: {
            DropFileHere: 'ここにファイルをドロップ',
            Or: 'または',
            SelectFile: 'ファイルを選択',
            SelectVideo: '.mp4を選択',
            SetAsVideo: 'ビデオとして設定',
            FileName: 'ファイル名',
            FileType: 'ファイルタイプ',
            Reselect: '再選択'
        },
        Video: {
            Transcripts: '*文字起こしは自動生成されています。不正確な場合があります。',
            Select: '選択',
            English: '英語',
            Spanish: 'スペイン語',
            French: 'フランス語',
            German: 'ドイツ語',
            Italian: 'イタリア語',
            Portuguese: 'ポルトガル語',
            Dutch: 'オランダ語',
            Russian: 'ロシア語',
            Chinese: '中国語',
            Japanese: '日本語',
            Korean: '韓国語',
            Arabic: 'アラビア語',
            Hindi: 'ヒンディー語'
        },
        Embed: {
            PoweredBy: '提供',
            JoinConversation: 'この会話に参加',
            EnterDetails: '下に詳細を入力',
            BackGuest: 'ゲストログインに戻る',
            ToGetStarted: '始めましょう！',
            OrUse: 'または使用',
            Name: '名前',
            Email: 'メール',
            StartRecording: '録画開始',
            Success: '接続しました！',
            StayTuned: 'さらなるWRADプロンプトにご期待ください！',
            VisitGravity: 'より多くのコラボレーションについてはusegravity.ioをご覧ください！',
            Sorry: '申し訳ありません、このプロンプトは埋め込みできません',
        }
    },
};

export default strings;